import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 480px;
  box-sizing: border-box;
  padding: 80px 40px;
  margin: 0 auto;
  gap: 40px;
  text-align: center;
`;

export const InputForm = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SpanEssential = styled.span`
  color: var(--alias-color-primary-normal);
  margin-left: 4px;
  text-decoration: none !important;
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: start;
`;

export const AgreeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin-top: 20px;
`;

export const LinkText = styled.p`
  text-decoration: underline;
  cursor: pointer;
`;
